import {evaluationNum} from "@/api/common/api";
export default {
  methods: {
    getEvaNum() {
      evaluationNum({})
        .then(({data})=>{
          // console.log(data);
          // 更新vuex测评数量
          Number(data.status) === 0 && this.$store.commit("updateEvaNum", Number(data.result.eva_status_N)||0);
        })
        .catch((err)=>{
          console.error(err);
        });
    }
  }
}